import React from 'react';

/**
 * Wandelt Zeilenumbrüche aus dem CMS in <br /> um. Damit lassen sich
 * mehrzeilige Überschriften pflegen, ohne HTML eingeben zu müssen.
 */
export function withLineBreaks(text) {
  if (!text) {
    return null;
  }
  return String(text)
    .split('\n')
    .map((line, index, all) => (
      <React.Fragment key={index}>
        {line}
        {index < all.length - 1 ? <br /> : null}
      </React.Fragment>
    ));
}

/** Stabile Kennung einer Bilderliste - dient als key für die Slider. */
export function imagesSignature(images) {
  return (images || []).map((image) => image.src).join('|');
}
